import { render, staticRenderFns } from "./clients-toolbar.vue?vue&type=template&id=3d72d8f2&"
import script from "./clients-toolbar.ts?vue&type=script&lang=ts&"
export * from "./clients-toolbar.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports